// employee/reducers.ts
const initialState = {
    getProductData: [],
    getProductCount: null,
    createProductData: null,
    updateProductData: null,
    getProductMetaMessage: null,
    getProductSuccess: false,
    getProductFailure: false,
    createProductSuccess: false,
    createProductFailure: false,
    updateProductSuccess: false,
    updateProductFailure: false,
    deleteProductSuccess: false,
    deleteProductFailure: false,
};

export default function ProductReducer(state = initialState, action: any) {
    switch (action.type) {
        case 'GET_PRODUCT_SUCCESS': {
            return {
                ...state,
                getProductSuccess: true,
                getProductData: action.payload?.data?.data?.data,
                getProductCount: action.payload?.data?.data?.meta?.total,
                getProductFailure: false,
            };
        }
        case 'GET_PRODUCT_FAILURE': {
            return {
                ...state,
                getProductFailure: true,
                getProductMetaMessage: action.payload?.data?.data?.meta?.message,
                getProductSuccess: false,
            };
        }
        case 'RESET_GET_PRODUCT': {
            return {
                ...state,
                getProductSuccess: false,
                getProductFailure: false,
                getProductData: [],
                getProductMetaMessage: null,
            };
        }

        case 'CREATE_PRODUCT_SUCCESS': {
            return {
                ...state,
                createProductSuccess: true,
                createProductData: action.payload?.data?.data?.data,
                getProductMetaMessage: action.payload?.data?.data?.meta?.message,
                createProductFailure: false,
            };
        }
        case 'CREATE_PRODUCT_FAILURE': {
            return {
                ...state,
                createProductFailure: true,
                getProductMetaMessage: action.payload?.data?.data?.meta?.message,
                createProductSuccess: false,
            };
        }
        case 'RESET_CREATE_PRODUCT': {
            return {
                ...state,
                createProductSuccess: false,
                createProductFailure: false,
                createProductData: null,
                getProductMetaMessage: null,
            };
        }

        case 'UPDATE_PRODUCT_SUCCESS': {
            return {
                ...state,
                updateProductSuccess: true,
                updateProductData: action.payload?.data?.data?.data,
                getProductMetaMessage: action.payload?.data?.data?.meta?.message,
                updateProductFailure: false,
            };
        }
        case 'UPDATE_PRODUCT_FAILURE': {
            return {
                ...state,
                updateProductFailure: true,
                getProductMetaMessage: action.payload?.data?.data?.meta?.message,
                updateProductSuccess: false,
            };
        }
        case 'RESET_UPDATE_PRODUCT': {
            return {
                ...state,
                updateProductSuccess: false,
                updateProductFailure: false,
                updateProductData: null,
                getProductMetaMessage: null,
            };
        }

        case 'DELETE_PRODUCT_SUCCESS': {
            return {
                ...state,
                deleteProductSuccess: true,
                getProductMetaMessage: action.payload?.data?.data?.meta?.message,
                deleteProductFailure: false,
            };
        }
        case 'DELETE_PRODUCT_FAILURE': {
            return {
                ...state,
                deleteProductFailure: true,
                getProductMetaMessage: action.payload?.data?.data?.meta?.message,
                deleteProductSuccess: false,
            };
        }
        case 'RESET_DELETE_PRODUCT': {
            return {
                ...state,
                deleteProductSuccess: false,
                deleteProductFailure: false,
                getProductMetaMessage: null,
            };
        }

        default: {
            return state;
        }
    }
}
